import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledConversationsList = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 3}px;
        overflow-y: auto;
    `
)

export const StyledEmptyState = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px;
        height: 100%;
        text-align: center;
    `
)
